import React from 'react'
import 'katex/dist/katex.min.css'
import NotebookPreview from '@nteract/notebook-preview'
import cat from "../pages/cat.png"

export default ({ data }) => {
  const post = data.jupyterNotebook
  const notebookJSON = JSON.parse(post.internal.content)
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ width: '100%' }}>
        <p>
        </p>

        <NotebookPreview notebook={notebookJSON} />
      </div>
    </div>
  )
}

export const query = graphql`
  query NotebookQuery($slug: String!) {
    jupyterNotebook(fields: { slug: { eq: $slug } }) {
      html
      internal {
        content
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/notebook.js